import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { DashboardComponent } from "./dashboard/dashboard.component";

import { MoreInfoComponent } from "./moreInfo/moreinfo.component";
import { AdminDashboardComponent } from "./admin_dashboard/admin_dashboard.component";
import { ReportsComponent } from "./Reports/reports.component";
import { FirmwareComponent } from "./firmware/firmware.component";
import { EntriesComponent } from "./entries/entries.component";

import { RecordSampleComponent } from "./records/recordsample.component";
import { RecordSampleGuardService } from "../core/guards/deactivate-guard";
import { OperatorDashboardComponent } from "./moreInfo/operator-dashboard/operator-dashboard.component";
import { MachineDataInfoComponent } from "./machine-data-info/machine-data-info.component";
import { AIVersionComponent } from "./ai-version/ai-version.component";
import { DetailedMachineDashboardComponent } from "./detailed-machine-dashboard/detailed-machine-dashboard.component";
import { HourlyProductionReportComponent } from "./Reports/hourly-production-report/hourly-production-report.component";
import { DetailedReportComponent } from "./Reports/detailed-report/detailed-report.component";
import { MachineReportComponent } from "./Reports/machine-report/machine-report.component";
import { LangingPageComponent } from "./dashboard/langing-page/langing-page.component";
import { ChatbotComponent } from "./dashboard/chatbot/chatbot.component";
import { PartwiseReportComponent } from "./Reports/partwise-report/partwise-report.component";
import { EnergyDashboardComponent } from "./dashboard/energy-dashboard/energy-dashboard.component";
import { AuditlogsComponent } from "./auditlogs/auditlogs.component";
import { OperatorPerformanceReportComponent } from "./Reports/operator-performance-report/operator-performance-report.component";
import { OemComponent } from "./oem/oem.component";
import { superdashboardComponent } from "../adminPage/superdashboard/superdashboard.component";
import { superUserComponent } from "./superUsers/superUser.component";



const routes: Routes = [
  { path: "", component: LangingPageComponent },
  { path: "energyDashboard", component: EnergyDashboardComponent },
  { path: "liveDashboard", component: DashboardComponent },
  { path: "chatbotComponent", component: ChatbotComponent },
  { path: "admin", component: AdminDashboardComponent },
  { path: "operator", component: OperatorDashboardComponent, canDeactivate: [RecordSampleGuardService] },
  { path: "machineData", component: MachineDataInfoComponent },
  { path: "detailedMachine", component: DetailedMachineDashboardComponent },
  { path: "reports", component: ReportsComponent },
  { path: "hourlyReport", component: HourlyProductionReportComponent },
  { path: "partwiseReport", component: PartwiseReportComponent },
  { path: "operatorReport", component: OperatorPerformanceReportComponent },
  { path: "detailedReport", component: DetailedReportComponent },
  { path: "machineReport", component: MachineReportComponent },
  { path: "entries", component: EntriesComponent },
  { path: "firmware", component: FirmwareComponent },
  { path: "auditlogs", component: AuditlogsComponent },
  { path: "aiConfig", component: AIVersionComponent },
  { path: 'superUser', component: superUserComponent },
  { path: 'oemAdmin', component: OemComponent },
  { path: 'superDashboard', component: superdashboardComponent },
  {
    path: "form",
    loadChildren: () => import("./form/form.module").then((m) => m.FormModule),
  },
  { path: "recordsample", component: RecordSampleComponent, canDeactivate: [RecordSampleGuardService] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule { }
